import styled from 'styled-components';

export const PageTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  color: var(--colBlack);
  padding: 12px 20px 12px;
  position: relative;
  top: 0;
  transition: 0.2s;
  &.on {
    opacity: 0;
    top: -12px;
  }

  /* PC */
  @media screen and (min-width: 768px) {
    font-size: 36px;
    line-height: 40px;
    padding: 32px 0 16px 0;
    &.small {
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
    }
  }
`;
